// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"432":"650fdee1","520":"ab5c198c","815":"259c7495"}[chunkId] + ".chunk.css";
};